import { render, staticRenderFns } from "./OnestopCompany.vue?vue&type=template&id=7dd282c8&scoped=true"
import script from "./OnestopCompany.vue?vue&type=script&lang=js"
export * from "./OnestopCompany.vue?vue&type=script&lang=js"
import style0 from "./OnestopCompany.vue?vue&type=style&index=0&id=7dd282c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd282c8",
  null
  
)

export default component.exports